import React from "react"
import Container from "../components/Container"
import Content from "../components/Content"
import Section from "../components/Section"
import Site from "../components/Site"
import "../css/404.scss"

const NotFoundPage = () => (
  <Site
    title     = "Page Not Found"
    className = "hcc-404"
  >
    <Section>
      <Container>
        <Content>
          <h1>We made an&nbsp;oopsie.</h1>
          <p>It seems whatever you&apos;re looking for is no&nbsp;longer&nbsp;here.&nbsp;<span role="img" aria-label="Sad Emoji">😢</span></p>
        </Content>
      </Container>
    </Section>
  </Site>
)

export default NotFoundPage
